"use strict";
/**
 *
 * FormNumberField/useFormNumberField
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFormMaskedField_1 = require("../FormMaskedField/useFormMaskedField");
const createNumberMask_1 = require("./createNumberMask");
function useFormNumberField(props) {
    const { prefix, suffix, includeThousandsSeparator, thousandsSeparatorSymbol, allowDecimal, decimalSymbol, decimalLimit, requireDecimal, allowNegative, allowLeadingZeroes, integerLimit, parseNumber } = props, formMaskedFieldProps = __rest(props, ["prefix", "suffix", "includeThousandsSeparator", "thousandsSeparatorSymbol", "allowDecimal", "decimalSymbol", "decimalLimit", "requireDecimal", "allowNegative", "allowLeadingZeroes", "integerLimit", "parseNumber"]);
    const mask = react_1.useMemo(() => createNumberMask_1.createNumberMask({
        prefix,
        suffix,
        includeThousandsSeparator,
        thousandsSeparatorSymbol,
        allowDecimal,
        decimalSymbol,
        decimalLimit,
        requireDecimal,
        allowNegative,
        allowLeadingZeroes,
        integerLimit,
    }), [
        prefix,
        suffix,
        includeThousandsSeparator,
        thousandsSeparatorSymbol,
        allowDecimal,
        decimalSymbol,
        decimalLimit,
        requireDecimal,
        allowNegative,
        allowLeadingZeroes,
        integerLimit,
    ]);
    const formMaskedField = useFormMaskedField_1.useFormMaskedField(Object.assign({ numberDecimalSymbol: decimalSymbol || createNumberMask_1.defaultDecimalSymbol, mask, parseNumber: parseNumber === undefined ? true : parseNumber }, formMaskedFieldProps));
    return formMaskedField;
}
exports.useFormNumberField = useFormNumberField;
